<template>
  <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="社会志愿者" class="h-100" name="2">
      <volunteer-info v-if="activeName == 2" :type="activeName"></volunteer-info>
    </el-tab-pane>
    <el-tab-pane label="小志愿者" class="h-100" name="3">
      <volunteer-info  v-if="activeName == 3" :type="activeName"></volunteer-info>
    </el-tab-pane>
    <el-tab-pane label="学校团体志愿者" class="h-100" name="4">
      <volunteer-info v-if="activeName == 4"  :type="activeName"></volunteer-info>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import volunteerInfo from './volunteer-info'
export default {
  components: {
    volunteerInfo
  },
  data() {
    return {
      activeName: "2",
      list: []
    }
  },

  methods: {
    handleClick(tab) {
      this.activeName = tab.name
    },
  },

  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.el-tabs {
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  /deep/.el-tabs__nav-wrap {
    &::after {
      display: none;
    }
    .el-tabs__nav-scroll {
      display: flex;
      justify-content: center;
    }
  }

  /deep/.el-tabs__content {
    flex: 1;
    overflow: auto;
    padding-bottom: 50px;
  }
}
</style>